import type { Novidade } from './tipos';

/** Fase 2, W8 (novidade na W17): Compras em camadas, com a compra direta no modo simplificado, e o modo de operação. */
export const novidadeCompras: Novidade = {
  id: '2026-10-05-compras',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'compras',
  permissao: 'compras.ver',
  rota: '/operacao/compras/compras',
  textos: {
    pt: {
      titulo: 'Compra direta e modo de operação do Compras',
      resumo: 'No modo simplificado, a compra entra de uma vez com a nota e as parcelas, e as contas a pagar nascem junto.',
      passos: [
        'Em Configurações, Modo de operação, escolha simplificado (compra direta) ou detalhado (requisição, cotação, pedido e recebimento).',
        'Em Operação, Compras, Nova compra registra o fornecedor, a nota fiscal, os itens ou a categoria, a condição e a forma de pagamento.',
        'As parcelas viram contas a pagar no Contas, com a competência, a nota e o centro de custo de cada item.',
        'Cancelar a compra cancela as contas ainda sem baixa; a compra cancelada pode ser excluída e fica 30 dias na lixeira.',
      ],
    },
    en: {
      titulo: 'Direct purchase and the Purchasing operating mode',
      resumo: 'In the simplified mode, the purchase goes in at once with the invoice and installments, and the payables come with it.',
      passos: [
        'In Settings, Operating mode, choose simplified (direct purchase) or detailed (requisition, quotation, order and receipt).',
        'In Operations, Purchasing, New purchase records the supplier, the invoice, the items or the category, the terms and the payment method.',
        'The installments become payables in Accounts, with the accrual period, the invoice and the cost center of each item.',
        'Canceling the purchase cancels the payables not yet settled; a canceled purchase can be deleted and stays 30 days in the trash.',
      ],
    },
    es: {
      titulo: 'Compra directa y modo de operación de Compras',
      resumo: 'En el modo simplificado, la compra entra de una vez con la factura y las cuotas, y las cuentas por pagar nacen junto.',
      passos: [
        'En Configuración, Modo de operación, elige simplificado (compra directa) o detallado (requisición, cotización, pedido y recepción).',
        'En Operación, Compras, Nueva compra registra el proveedor, la factura, los ítems o la categoría, la condición y la forma de pago.',
        'Las cuotas se vuelven cuentas por pagar en Cuentas, con la competencia, la factura y el centro de costo de cada ítem.',
        'Cancelar la compra cancela las cuentas aún sin pago; la compra cancelada puede borrarse y queda 30 días en la papelera.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-compras/modos.webp', '/novidades/2026-10-05-compras/compras.webp', null, null],
  treinamento: { curso: 'novidades' },
};
